import React, {Fragment, useRef, useState} from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import LocationIcon from '@material-ui/icons/Place';
import { Field} from 'react-final-form';
import {Select, Text} from './';


export default function AddressInput(props){

  function getCountry(id, countries){if(countries!=undefined){for(let c of countries){if(c.id==id){return c.name;}}}}

  function getAddress(x){
    let address='';
    if(x.street!='' && x.street!=undefined){address+=x.street;}
    if(x.city!='' && x.city!=undefined){address+=', '+x.city;}
    if(x.postal_code!='' && x.postal_code!=undefined){address+=' ('+x.postal_code+')'}
    if(x.region!='' && x.region!=undefined){address+=' - '+x.region;}
    if(x.country_id!='' && x.country_id!=undefined){address+=' - '+getCountry(x.country_id, props.countries)}
    return address;

  }


  return(
    <Grid container>
    <Grid item xs={12}><Field name={props.name}>{(fff)=><Typography variant='caption' style={{marginBottom:'15px', width:'100%',paddingLeft:'15px', color:(props.disabled==true)?'grey':undefined}} color='primary'><LocationIcon style={{ fontSize: '17px', marginRight: '5px', marginBottom:'-4px' }} />{getAddress(fff.input.value)}</Typography>}</Field></Grid>
    <Grid item xs={7}><Text title="Street" name={props.name+".street"} disabled={props.disabled} required/></Grid>
    <Grid item xs={5}><Text title="City" name={props.name+".city"} disabled={props.disabled} required/></Grid>
    <Grid item xs={4}><Text title="Region" name={props.name+".region"} disabled={props.disabled}/></Grid>
    <Grid item xs={4}><Text title="Postal code" name={props.name+".postal_code"} disabled={props.disabled}/></Grid>
    <Grid item xs={4}><Select title="Country" name={props.name+".country_id"} select_data={props.countries} disabled={props.disabled} required style={{marginTop:'5px'}}/></Grid>
    </Grid>
  )
}
